var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { generateOptionsFromNumber } from '../../../helpers/formGeneratorHelper';
import { parseTime } from '../../../helpers/dateHelper';
import './APTimePickerDropdown.css';
import { minTime, maxTime } from '../../../helpers/formValidations';
var APTimePickerDropdown = function (_React$Component) {
  _inherits(APTimePickerDropdown, _React$Component);
  function APTimePickerDropdown(props) {
    _classCallCheck(this, APTimePickerDropdown);
    var _this = _possibleConstructorReturn(this, (APTimePickerDropdown.__proto__ || Object.getPrototypeOf(APTimePickerDropdown)).call(this, props));
    _this.setIsAM = function (date) {
      _this.setState({
        isAM: date.getHours() < 12
      });
    };
    _this.handleChange = function (date) {
      _this.props.input.onChange(date);
      if (_this.props.customChange) {
        _this.props.customChange(date);
      }
      _this.setIsAM(date);
      _this.setState({
        date: new Date(date)
      });
    };
    _this.getClasses = function () {
      var customClasses = _this.props.customClasses;
      return getBEMClasses(['ap-timepicker-dropdown', 'ap-select', customClasses]);
    };
    _this.getHours = function () {
      var _this$props = _this.props,
        isAMPM = _this$props.isAMPM,
        leadingZero = _this$props.leadingZero;
      return generateOptionsFromNumber(isAMPM ? 1 : 0, isAMPM ? 13 : 24, leadingZero ? 2 : 0);
    };
    _this.onHoursChange = function (e) {
      var value = e.target.value;
      var _this$state = _this.state,
        date = _this$state.date,
        isAM = _this$state.isAM;
      var isAMPM = _this.props.isAMPM;
      var hours = +value;
      if (hours === 12) {
        hours = isAM ? 0 : 12;
      } else {
        hours = isAMPM && !isAM ? +value + 12 : +value;
      }
      date.setHours(hours);
      _this.handleChange(date);
    };
    _this.onMinutesChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      date.setMinutes(value);
      _this.handleChange(date);
    };
    _this.getCurrentValue = function () {
      var _this$state2 = _this.state,
        date = _this$state2.date,
        isAM = _this$state2.isAM;
      var isAMPM = _this.props.isAMPM;
      var hours = date.getHours();
      if (isAMPM) {
        if (isAM) {
          hours = hours === 0 ? 12 : hours;
        } else {
          hours = hours === 12 ? hours : hours - 12;
        }
      }
      return {
        hours: hours,
        minutes: date.getMinutes()
      };
    };
    _this.onAmPmChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      var hours = date.getHours();
      hours = value === 'AM' ? hours - 12 : hours + 12;
      date.setHours(hours);
      _this.handleChange(date);
    };
    _this.state = {
      date: new Date(0, 0, 0, 0, 0, 0),
      isAM: true
    };
    return _this;
  }
  _createClass(APTimePickerDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.props.input.value;
      if (value) {
        var date = new Date(value);
        this.setState({
          date: date
        });
        this.setIsAM(date);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        label = _props.label,
        meta = _props.meta,
        info = _props.info,
        customClass = _props.customClass,
        leadingZero = _props.leadingZero,
        isAMPM = _props.isAMPM,
        otherProps = _objectWithoutProperties(_props, ['label', 'meta', 'info', 'customClass', 'leadingZero', 'isAMPM']);
      var isAM = this.state.isAM;
      var baseClasses = this.getClasses();
      var value = this.getCurrentValue();
      return React.createElement('div', {
        className: 'form-group ' + baseClasses('select-wrapper')
      }, React.createElement('label', {
        className: 'ap--label ' + baseClasses('label')
      }, label), React.createElement('div', {
        className: baseClasses('input')
      }, React.createElement('select', Object.assign({
        value: value.hours,
        className: baseClasses('select'),
        onChange: this.onHoursChange
      }, otherProps), this.getHours()), React.createElement('select', Object.assign({
        value: value.minutes,
        className: baseClasses('select'),
        onChange: this.onMinutesChange
      }, otherProps), generateOptionsFromNumber(0, 60, leadingZero ? 2 : 0)), isAMPM && React.createElement('select', Object.assign({
        value: isAM ? 'AM' : 'PM',
        className: baseClasses('select'),
        onChange: this.onAmPmChange
      }, otherProps), React.createElement('option', null, 'PM'), React.createElement('option', null, 'AM'))), React.createElement('div', {
        className: 'form-text-muted ' + baseClasses('info')
      }, info), meta.dirty && meta.error && React.createElement('div', {
        className: baseClasses('error', 'dpk-error')
      }, meta.error));
    }
  }]);
  return APTimePickerDropdown;
}(React.Component);
APTimePickerDropdown.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  customClass: PropTypes.string,
  info: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  disabled: PropTypes.bool,
  leadingZero: PropTypes.bool,
  minTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  maxTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
};
APTimePickerDropdown.contextTypes = {
  t: PropTypes.func
};
APTimePickerDropdown.defaultProps = {
  label: 'Time',
  info: '',
  disabled: false,
  leadingZero: true
};
var minTimeProp = void 0;
var maxTimeProp = void 0;
var minTimeValidation = function minTimeValidation(value) {
  return minTimeProp && minTime(value, parseTime(minTimeProp));
};
var maxTimeValidation = function maxTimeValidation(value) {
  return maxTimeProp && maxTime(value, parseTime(maxTimeProp));
};
var maxMinValidations = [minTimeValidation, maxTimeValidation];
export default function APTimePicker(props) {
  var validate = props.validate,
    minTime = props.minTime,
    maxTime = props.maxTime,
    otherProps = _objectWithoutProperties(props, ['validate', 'minTime', 'maxTime']);
  minTimeProp = minTime;
  maxTimeProp = maxTime;
  var validators = validate ? [].concat(_toConsumableArray(validate), maxMinValidations) : maxMinValidations;
  return React.createElement(Field, Object.assign({}, otherProps, {
    name: props.name,
    component: APTimePickerDropdown,
    validate: validators
  }));
}
export { APTimePickerDropdown };